/**
 * sus.ts — Auditoria do SUS: pareceres técnicos (F9).
 */

import type { components } from './generated/api'
import { api } from './http'

export type ParecerResumo = components['schemas']['ParecerResumo']
export type DocumentoParecer = components['schemas']['DocumentoParecer']
export type FormularioParecer = components['schemas']['FormularioParecer']
export type ConfiguracaoSUS = components['schemas']['ConfiguracaoSUS']
export type NovoParecerInput = components['schemas']['NovoParecerInput']
export type GeracaoParecer = components['schemas']['GeracaoParecer']

export function configuracaoSUS() {
  return api<ConfiguracaoSUS>('/api/v1/sus/configuracao')
}

export function listarPareceres() {
  return api<{ pareceres: ParecerResumo[] }>('/api/v1/sus/pareceres')
}

export type ItemCatalogoSUS = components['schemas']['ItemCatalogoSUS']
export type ContextoAnterior = components['schemas']['ContextoAnterior']

/** Anexos do parecer sobem junto: o multipart carrega tudo num pedido só. */
export function criarParecer(dados: NovoParecerInput, anexos: File[] = []) {
  if (!anexos.length) {
    return api<GeracaoParecer>('/api/v1/sus/pareceres', {
      method: 'POST',
      body: dados,
    })
  }
  const form = new FormData()
  for (const [campo, valor] of Object.entries(dados)) {
    if (Array.isArray(valor)) valor.forEach((v) => form.append(campo, v))
    else form.append(campo, String(valor ?? ''))
  }
  anexos.forEach((a) => form.append('documentos', a))
  return api<GeracaoParecer>('/api/v1/sus/pareceres', { method: 'POST', form })
}

export function buscarNoCatalogoSUS(
  tipo: 'medicamento' | 'procedimento',
  termo: string,
) {
  return api<{ itens: ItemCatalogoSUS[] }>(
    `/api/v1/sus/catalogo?tipo=${tipo}&termo=${encodeURIComponent(termo)}`,
  )
}

export function contextosAnteriores(termo = '') {
  return api<{ contextos: ContextoAnterior[] }>(
    `/api/v1/sus/contextos?termo=${encodeURIComponent(termo)}`,
  )
}

export function melhorarContexto(contexto: string, tipo: string) {
  return api<{ contexto: string }>('/api/v1/sus/contexto/melhorar', {
    method: 'POST',
    body: { contexto, tipo: tipo || 'Documento SUS' },
  })
}

export function documentoParecer(id: number) {
  return api<DocumentoParecer>(`/api/v1/sus/pareceres/${id}`)
}

export function formularioParecer(id: number) {
  return api<FormularioParecer>(`/api/v1/sus/pareceres/${id}/formulario`)
}

export function salvarParecer(id: number, dados: FormularioParecer) {
  return api<DocumentoParecer>(`/api/v1/sus/pareceres/${id}`, {
    method: 'PUT',
    body: dados,
  })
}

export function excluirParecer(id: number) {
  return api<{ removido: boolean }>(`/api/v1/sus/pareceres/${id}`, {
    method: 'DELETE',
  })
}
